import { render } from "./MarketingCard.vue?vue&type=template&id=44cb6240&scoped=true"
import script from "./MarketingCard.vue?vue&type=script&lang=js"
export * from "./MarketingCard.vue?vue&type=script&lang=js"

import "./MarketingCard.vue?vue&type=style&index=0&id=44cb6240&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cb6240"]])

export default __exports__